// JS que pinta datos de producto en pop quick view

$(document).ready(function(){
    // variables

    // acciones
    $('body').on('click', '.js-quick__action', function(event) {
        event.preventDefault()
        quick($(this))
    })

    $('body').on('click', '.js-slide-product-quick__action', function(event) {
        slideProductQuickVariant($(this))
    })

    // funciones
    function quick(action) {
        const product_url = action.data('quick__url')
        const product_images = action.data('quick__images')
        const product_images_variants = action.data('quick__images-variants')
        const product_time = action.data('quick__time')
        const product_tags = action.data('quick__tags')
        const product_title = action.data('quick__title')
        const product_variants = action.data('quick__variants')
        const product_options = action.data('quick__options')
        const file_url = action.data('quick__file')
        const product_available = action.data('quick__available')
        const product_type = action.data('quick__type')
        const product_guia = action.data('quick__guia')

        $('.js-quick__images').each( function (){
            $(this).html( quickImages(product_images, product_url, product_time, product_images_variants) )
        })

        $('.js-quick__action-wish').each( function (){
            $(this).html( quickActionWish() )
        })

        $('.js-quick__action-view').each( function (){
            $(this).html( quickActionView(product_images) )
        })
        
        $('.js-quick__tags').each( function (){
            $(this).html( quickTags(product_tags) )
        })

        $('.js-quick__titles').each( function (){
            $(this).html( quickTitles(product_title) )
        })

        $('.js-quick__prices').each( function (){
            $(this).html( quickVariants(product_variants) )
        })

        $('.js-quick__sizes').each( function (){
            $(this).html( quickSizes(product_options, product_type, product_guia), product_guia )
        })

        $('.js-quick__colors').each( function (){
            $(this).html( quickColors(product_options, file_url) )
        })

        $('.js-quick__available').each( function (){
            $(this).html( quickAvailable(product_available) )
        })

        slideProductQuick()
    }

    // 
    function quickImages(images, url, time, images_variants){
        let code = ''
        
        let forlopp = 0
        
        let images_slide = ''
        let images_slide_arrows = ''
        let images_slide_time = ''
        let images_self = ''
        
        const image_variants_self = images_variants.split(',')

        if (images.length > 0) {
            images.forEach(image => {

                let img_variant = ''
                image_variants_self.forEach(variant => {
                    const image_split = image.split('products')
                    const image_split_2 = image_split[1].split('.jpg')
                    const image_variant_split = `products${image_split_2[0]}`

                    if (variant.includes(image_variant_split)) {
                        const variant_split = variant.split('jpg-')
                        img_variant = variant_split[1]
                    }
                })

                let img = ''
                img = `
                    <div class="d-block h-auto js-slide-product-quick__variant" data-slide-product-quick__variant="${img_variant}" data-slide-product-quick__position="${forlopp}">
                        <img class="d-block w-100" src="${image}" alt="">
                    </div>
                `
                images_self += img
                forlopp += 1
            })

            images_slide = 'js-slide-product__content-quick'
            images_slide_arrows = `
                <div class="c-card-product__arrows">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="c-arrow js-slide-product__prev-quick">
                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="assets-haggar/iconos/24px/icon-arrow-backward2_darkgray" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="ico-/-24-/-arrows-/-arrow_forward-copy-3" fill="#575756">
                                        <path d="M22,11.5 L22,12.5 C22,12.7761424 21.7761424,13 21.5,13 L5.33,13 L9.78,17.44 C9.87465633,17.5338833 9.92789916,17.6616812 9.92789916,17.795 C9.92789916,17.9283188 9.87465633,18.0561167 9.78,18.15 L9.07,18.85 C8.9761167,18.9446563 8.84831877,18.9978992 8.715,18.9978992 C8.58168123,18.9978992 8.4538833,18.9446563 8.36,18.85 L2.22,12.72 C2.07930751,12.5794826 2,12.3888454 2,12.19 L2,11.81 C2.00230401,11.6115859 2.08111602,11.4217206 2.22,11.28 L8.36,5.15 C8.4538833,5.05534367 8.58168123,5.00210084 8.715,5.00210084 C8.84831877,5.00210084 8.9761167,5.05534367 9.07,5.15 L9.78,5.86 C9.87406407,5.95216359 9.92707144,6.07831031 9.92707144,6.21 C9.92707144,6.34168969 9.87406407,6.46783641 9.78,6.56 L5.33,11 L21.5,11 C21.7761424,11 22,11.2238576 22,11.5 Z" id="Icon-color"></path>
                                    </g>
                                </g>
                            </svg>
                        </span>
                        <span class="c-arrow js-slide-product__next-quick">
                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="assets-haggar/iconos/24px/icon-arrow-forward2_darkgray" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="ico-/-24-/-arrows-/-arrow_forward-copy-2" fill="#575756">
                                        <path d="M2,12.5 L2,11.5 C2,11.2238576 2.22385763,11 2.5,11 L18.67,11 L14.22,6.56 C14.1253437,6.4661167 14.0721008,6.33831877 14.0721008,6.205 C14.0721008,6.07168123 14.1253437,5.9438833 14.22,5.85 L14.93,5.15 C15.0238833,5.05534367 15.1516812,5.00210084 15.285,5.00210084 C15.4183188,5.00210084 15.5461167,5.05534367 15.64,5.15 L21.78,11.28 C21.9206925,11.4205174 22,11.6111546 22,11.81 L22,12.19 C21.997696,12.3884141 21.918884,12.5782794 21.78,12.72 L15.64,18.85 C15.5461167,18.9446563 15.4183188,18.9978992 15.285,18.9978992 C15.1516812,18.9978992 15.0238833,18.9446563 14.93,18.85 L14.22,18.14 C14.1259359,18.0478364 14.0729286,17.9216897 14.0729286,17.79 C14.0729286,17.6583103 14.1259359,17.5321636 14.22,17.44 L18.67,13 L2.5,13 C2.22385763,13 2,12.7761424 2,12.5 Z" id="Icon-color"></path>
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
            `
            images_slide_time = `
                <div class="c-time"><span class="c-time__line js-slide-product__bar-quick" style="width: ${time}%"></span></div>
            `

        }else{
            images_self = `
                <div class="d-block">
                    <img class="d-block w-100" style="opacity: 0;" src="https://picsum.photos/255/255" alt="">
                </div>
            `
        }
        
        const item = `
            <a class="d-block position-relative" href="${url}">
                <div class="d-block ${images_slide}">
                    ${images_self}
                </div>
            </a>

            ${images_slide_time}
            ${images_slide_arrows}
        `
        code += item
        return code
    }

    function quickActionWish(){
        let code = ''
        
        const item = `
            <a class="c-action" href="#">
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="assets-haggar/iconos/menu/24px/icon-wishlist_outlined_normal" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Group" fill="#000000" fill-rule="nonzero">
                            <g id="Icon-color">
                                <path d="M16.5,3 C14.7819016,3.05353575 13.1586346,3.8002386 12,5.07 C10.8413654,3.8002386 9.21809836,3.05353575 7.5,3 C4.46243388,3 2,5.46243388 2,8.5 C2,12.42 6.75,16.75 9,19 L11.28,21.28 C11.4205174,21.4206925 11.6111546,21.5 11.81,21.5 L12.19,21.5 C12.3888454,21.5 12.5794826,21.4206925 12.72,21.28 L15,19 C17.25,16.75 22,12.42 22,8.5 C22,5.46243388 19.5375661,3 16.5,3 Z M14.2,17 L12,19.17 L9.8,17 C7.77,15 4,11.26 4,8.5 C4,6.56700338 5.56700338,4.99987125 7.5,4.99987125 L7.5,4.99987125 C9.00743345,5.13712384 10.3716031,5.94974241 11.21,7.21 C11.355645,7.39268909 11.5763606,7.49936827 11.81,7.5 L12.26,7.5 C12.4170122,7.49846435 12.5645642,7.42468834 12.66,7.3 C13.5119185,5.99151791 14.9153102,5.1443261 16.47,4.99987125 L16.47,4.99987125 C17.4034447,4.99199875 18.3014099,5.35721243 18.96429,6.01445898 C19.6271701,6.67170554 20,7.566521 20,8.5 C20,11.26 16.23,15 14.2,17 Z"></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </a>
        `
        code += item
        return code
    }

    function quickActionView(images){
        let code = ''
        
        const item = `
        <a href="#" class="c-action js-pop__action js-quick-image__action" data-pop__id="pop-view" data-pop__active="is-pop"      data-quick-image__images='${JSON.stringify(images)}'>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="assets-haggar/iconos/24px/icon-eye-visible_black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="ico-/-24-/-actions-/-heart_outlined-copy" fill="#27251F">
                        <path d="M21.9878209,11.7 L21.9878209,11.7 C20.3582098,7.6164597 16.388065,4.95484182 11.9939104,5 C7.62898705,4.97475246 3.69112859,7.61876858 2.05996346,11.67 L2.05996346,11.67 C2.02155037,11.7758375 2.00127745,11.8874065 1.99998995,12 C1.99947104,12.1062688 2.01984591,12.2116031 2.05996346,12.31 L2.05996346,12.31 C3.68477833,16.3690887 7.62404986,19.0219846 11.9939104,19 C16.3588338,19.0252475 20.2966923,16.3812314 21.9278574,12.33 L21.9278574,12.33 C21.9706365,12.225391 21.9910622,12.1129814 21.9878209,12 L21.9878209,12 C22.0040463,11.900659 22.0040463,11.799341 21.9878209,11.7 Z M11.9939104,17 C8.61239363,16.9923837 5.53329177,15.0497746 4.06873946,12 C5.52822989,8.94598178 8.61074867,7.00199156 11.9939104,7.00199156 C15.3770722,7.00199156 18.459591,8.94598178 19.9190814,12 C18.4545291,15.0497746 15.3754272,16.9923837 11.9939104,17 Z M11.9939104,10 C13.0978073,10 13.9926925,10.8954305 13.9926925,12 C13.9926925,13.1045695 13.0978073,14 11.9939104,14 C10.8900136,14 9.99512835,13.1045695 9.99512835,12 C9.99512835,10.8954305 10.8900136,10 11.9939104,10 L11.9939104,10 Z M11.9939104,8 C9.78611671,8 7.99634626,9.790861 7.99634626,12 C7.99634626,14.209139 9.78611671,16 11.9939104,16 C14.2017042,16 15.9914746,14.209139 15.9914746,12 C15.9914746,9.790861 14.2017042,8 11.9939104,8 L11.9939104,8 Z" id="Icon-color"></path>
                    </g>
                </g>
            </svg>
        </a>
        `
        code += item
        return code
    }

    function quickTags(tags){
        const tags_self = tags.split(',')
        let code = ''

        let tags_print = ''
        tags_self.forEach(tag => {
            let tag_text = ''

            if (tag.includes('tag_')) {
                const tag_replace = tag.replace('tag_','');

                tag_text = `
                    <div class="c-tag">
                        <div class="c-tag__text">${tag_replace}</div>
                    </div>
                `
            }

            tags_print += tag_text
        })
        
        const item = `
            <div class="c-card-product__tags">
                <div class="d-flex flex-column">
                    ${tags_print}
                </div>
            </div>
        `
        code += item
        return code
    }

    function quickTitles(title){
        let code = ''
        
        const item = `
            <div class="text-center">
                <h3 class="c-card-product__title c-card-product__title--average u-color__base">${title}</h3> 
            </div>
        `
        code += item
        return code
    }

    function quickVariants(variants){
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2
        })

        let code = ''

        let forlopp = 0
        let prices_self = ''
        let self_active = ''

        variants.forEach(variant => {
            if (variant.available) {
                
                let item = ''
    
                if (forlopp == 0) {
                    self_active = 'd-block'
                }else{
                    self_active = ''
                }
    
                item = `
                    <div class="d-none ${self_active} text-center js-switch__content js-switch-add__id" data-switch__id="switch-quick" data-switch__active="d-block" data-switch__value="${variant.title}"      data-switch-add__id="switch-add-quick" data-switch-add__key="${variant.id}" data-switch-add__active="d-block">
                        <p class="c-card-product__price u-color__active">MXN $${ formatter.format(variant.price/100) }</p>
                    </div>
                `
                prices_self += item
                forlopp += 1
            }
        })
        
        const item = `
            ${prices_self}
        `
        code += item
        return code
    }

    function quickSizes(options, product_type, product_guia){
        let code = ''

        let forlopp = 0
        let sizes_self = ''
        let self_active = ''
        let self_active_content = ''

        let options_count = 0
        options.forEach(option => {
            if ( option.name == 'Size' || option.name == 'Talla') {
                options_count += 1
            }
        })

        let size_guia = ''
        // if (product_guia) {
        //     size_guia = `
        //         <div class="js-tab__action" data-tab__id="tab-size-content" data-tab__active="is-tab" data-tab__tab="tab-size-${product_type}">
        //             <a class="c-link-icon js-pop__action" data-pop__id="tab-pop-size" data-pop__active="is-pop" href="#">
        //                 <span class="c-link-icon__icon">
    
        //                     <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        //                         <g id="assets-haggar/iconos/24px/icon-ruler-tallas_gold" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        //                             <g id="ico-/-24-/-media-&amp;-editing-/-ruler" transform="translate(2.000000, 2.000000)" fill="#AB9D62">
        //                                 <path d="M18.0916667,4.84166667 L15.1583333,1.90833333 C15.0031161,1.75437986 14.7936166,1.66758718 14.575,1.66665272 L13.9666667,1.66665272 C13.7451642,1.66538603 13.5322657,1.75234457 13.375,1.90833333 L1.90833333,13.375 C1.75234457,13.5322657 1.66538603,13.7451642 1.66665272,13.9666667 L1.66665272,14.575 C1.66758718,14.7936166 1.75437986,15.0031161 1.90833333,15.1583333 L4.84166667,18.0916667 C4.99688387,18.2456201 5.20638344,18.3324128 5.425,18.3333333 L6.03333333,18.3333333 C6.26915112,18.3461603 6.49933713,18.2583262 6.66666667,18.0916667 L18.0916667,6.66666667 C18.2583262,6.49933713 18.3461603,6.26915112 18.3333333,6.03333333 L18.3333333,5.425 C18.3324128,5.20638344 18.2456201,4.99688387 18.0916667,4.84166667 Z M5.73333333,16.6666667 L3.375,14.2666667 L4.20833333,13.475 L5.09166667,14.3583333 C5.2536848,14.5171429 5.51298187,14.5171429 5.675,14.3583333 L6.125,13.9083333 C6.28380953,13.7463152 6.28380953,13.4870181 6.125,13.325 L5.20833333,12.4416667 L6.24166667,11.4083333 L6.70833333,11.875 C6.87035146,12.0338095 7.12964854,12.0338095 7.29166667,11.875 L7.74166667,11.425 C7.9004762,11.2629819 7.9004762,11.0036848 7.74166667,10.8416667 L7.275,10.375 L8.33333333,9.34166667 L9.16666667,10.225 C9.3286848,10.3838095 9.58798187,10.3838095 9.75,10.225 L10.2,9.775 C10.3588095,9.61298187 10.3588095,9.3536848 10.2,9.19166667 L9.34166667,8.33333333 L10.375,7.3 L10.8416667,7.76666667 C11.0036848,7.9254762 11.2629819,7.9254762 11.425,7.76666667 L11.875,7.31666667 C12.0338095,7.15464854 12.0338095,6.89535146 11.875,6.73333333 L11.4083333,6.26666667 L12.4416667,5.23333333 L13.3333333,6.09166667 C13.4953515,6.2504762 13.7546485,6.2504762 13.9166667,6.09166667 L14.3666667,5.64166667 C14.5254762,5.47964854 14.5254762,5.22035146 14.3666667,5.05833333 L13.475,4.16666667 L14.2666667,3.33333333 L16.6666667,5.73333333 L5.73333333,16.6666667 Z" id="Icon-color"></path>
        //                             </g>
        //                         </g>
        //                     </svg>
                            
        //                 </span>
        //                 <span class="c-link-icon__link">GUÍA DE TALLAS</span>
        //             </a>
        //         </div>
        //     `
        // }

        if (options_count) {
            options.forEach(option => {
                if ( option.name == 'Size' || option.name == 'Talla') {
                    option.values.forEach(value => {
                        let item = ''
    
                        if (forlopp == 0) {
                            self_active = 'is-active is-switch'
                            self_active_content = 'is-tab'
                        }else{
                            self_active = ''
                            self_active_content = ''
                        }
    
                        item = `
                            <div class="col-2 col-lg-3 px-2 c-options-size ${self_active_content} js-tab__action mb-3" data-tab__id="quick-size" data-tab__tab="tab-option-size-${forlopp}" data-tab__active="is-tab">
                                <div class="c-options-size__item c-options-size__item--active ${self_active} js-tab__content js-switch__action" data-tab__id="quick-size" data-tab__tab="tab-option-size-${forlopp}" data-tab__active="is-active is-switch"     data-switch__id="switch-quick" data-switch__position="${option.position}" data-switch__value="${value}"><span class="c-options-size__text c-options-size__text--active">${value.toUpperCase()}</span></div>
                            </div>
                        `
                        sizes_self += item
                        forlopp += 1
    
                    })
                }
            })
            
            const item = `
                <h3 class="c-product-info__titles mb-4 js-tab__context" data-tab__id="quick-size" data-tab__option="true">TALLA</h3>
                <div class="px-2">
                    <div class="row mb-3">
                        ${sizes_self}
                    </div>
                </div>
    
                ${size_guia}
            `
            code += item
        }
        
        return code
    }

    function quickColors(options, file_url){
        let code = ''

        let forlopp = 0
        let colors_self = ''
        let self_active = ''

        let options_count = 0
        options.forEach(option => {
            if ( option.name == 'Color' || option.name == 'color') {
                options_count += 1
            }
        })

        if (options_count) {
            options.forEach(option => {
                if ( option.name == 'Color' || option.name == 'color') {
                    option.values.forEach(value => {
                        let item = ''
                        const value_handle = value.toLowerCase().replace(/ /g,'-')
                        const value_image = file_url.replace("atom", `${value_handle}`)
    
                        if (forlopp == 0) {
                            self_active = 'is-active is-switch'
                        }else{
                            self_active = ''
                        }
    
                        item = `
                            <div class="col-2 col-lg-2 px-2 mb-3 js-tab__action js-slide-product-quick__action" data-tab__id="quick-color" data-tab__tab="tab-option-${forlopp}" data-tab__active="is-tab"     data-slide-product-quick__variant="${value}">
                                <div class="c-options-color__item c-tooltip ${self_active} js-tab__content js-switch__action" data-tab__id="quick-color" data-tab__tab="tab-option-${forlopp}" data-tab__active="is-active is-switch"      data-switch__id="switch-quick" data-switch__position="${option.position}" data-switch__value="${value}">
                                    <div class="c-tooltip__content">${value}</div>
                                    <span class="c-options-color__color">
                                        <img class="w-100" src="${value_image}" alt="${value}">
                                        
                                        <svg width="300px" height="300px" viewBox="0 0 300 300" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="assets/iconos/check" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="Group" fill="#000305" fill-rule="nonzero">
                                                    <g id="ico-/-24-/-actions-/-done">
                                                        <path d="M248.125,90.625 L115.625,223.125 C114.451459,224.308204 112.853985,224.97374 111.1875,224.97374 C109.521015,224.97374 107.923541,224.308204 106.75,223.125 L39.375,155.75 C38.1917959,154.576459 37.5262605,152.978985 37.5262605,151.3125 C37.5262605,149.646015 38.1917959,148.048541 39.375,146.875 L48.125,138.125 C49.2985412,136.941796 50.8960154,136.27626 52.5625,136.27626 C54.2289846,136.27626 55.8264588,136.941796 57,138.125 L111.125,192.25 L230.5,72.875 C232.972671,70.4777089 236.902329,70.4777089 239.375,72.875 L248.125,81.75 C249.308204,82.9235412 249.97374,84.5210154 249.97374,86.1875 C249.97374,87.8539846 249.308204,89.4514588 248.125,90.625 Z" id="Icon-color"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
    
                                    </span>
                                </div>
                            </div>
                        `
                        colors_self += item
                        forlopp += 1
    
                    })
                }
            })
            
            const item = `
                <h3 class="c-product-info__titles mb-4 js-tab__context" data-tab__id="quick-color" data-tab__option="true">COLOR</h3>
                <div class="px-2">
                    <div class="row mb-3">
                        ${colors_self}
                    </div>
                </div>
            `
            code += item
        }

        return code
    }

    function quickAvailable(available) {
        $('.js-quick__available').each( function (){
            if (available) {
                if ( $(this).data('quick__view') ) {
                    $(this).addClass( $(this).data('quick__active') )
                }else{
                    $(this).removeClass( $(this).data('quick__active') )
                }
            }else{
                if ( $(this).data('quick__view') ) {
                    $(this).removeClass( $(this).data('quick__active') )
                }else{
                    $(this).addClass( $(this).data('quick__active') )
                }
            }
        })
    }

    // 
    function slideProductQuick() {
        $(`.js-slide-product__content-quick`).slick({
            dots: false,
            arrows: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 7000,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            prevArrow: $(`.js-slide-product__prev-quick`),
            nextArrow: $(`.js-slide-product__next-quick`),
        })

        $(`.js-slide-product__content-quick`).on('init reInit afterChange', function (event, slick, currentSlide) {
            const i = (currentSlide ? currentSlide : 0)
            const total = slick.slideCount
            const width_total_self = 100 / total
            const width_total = width_total_self * i
            const width_bar = width_total + '%'

            $(`.js-slide-product__bar-quick`).css("left", width_bar)
        })
    }

    function slideProductQuickVariant(action) {
        $('.js-slide-product-quick__variant').each( function (){
            if ( $(this).data('slide-product-quick__variant').includes(action.data('slide-product-quick__variant')) ) {
                $(`.js-slide-product__content-quick`).slick('slickGoTo', `${$(this).data('slide-product-quick__position')}`)
            }
        })
    }
})
